import { CodeDeployment } from "@amzn/amazonmq-opsconsole-client";
import { RebootEvent } from "../../../types";

export function copyMarkdown(
    asgName: string, 
    asgArn: string, 
    latestDeployment: CodeDeployment | undefined, 
    latestStep: RebootEvent | undefined,
    failedEvents: RebootEvent[] = []
) {
    const failedEventsMarkdown = failedEvents.length > 0 
        ? [
            '',
            '### Failed Events',
            '',
            ...failedEvents.map(event => 
                `- **${event.type}** (${new Date(event.timestamp).toLocaleString()})`
            )
          ].join('\n')
        : '';

    const markdown = [
        '## Broker Restart Information',
        '',
        `**ASG Name:** ${asgName || 'N/A'}`,
        `**ASG ARN:** ${asgArn || 'N/A'}`,
        `**Latest Deployment:** ${latestDeployment ? latestDeployment.deploymentId : 'N/A'}`,
        `**Latest Step:** ${latestStep ? latestStep.type : 'N/A'}`,
        failedEventsMarkdown,
        ''
    ].join('\n');

    navigator.clipboard.writeText(markdown)
        .then(() => {
            console.log('Markdown copied to clipboard');
        })
        .catch(err => {
            console.error('Failed to copy markdown to clipboard', err);
        });
}
